import PropTypes from 'prop-types';
import ButtonMui from '@mui/material/Button';

function Button(props) {
  const { children, variant = 'contained', color = 'primary', ...restProps } = props
  return (
    <ButtonMui variant={variant} color={color} {...restProps}>
      {children}
    </ButtonMui>
  )
}

// Prop validation
Button.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  color: PropTypes.string,
};

export default Button
